// Internal dependencies
const {
    generateBackgroundAttributes,
    generateBorderAttributes,
    generateResBoxControlAttributes,
    generateTypographyAttributes,
    generateResRangeAttributes
} = window.faqmateModules;

// constants
import {
    C_BG,
    C_BORDER,
    C_BRADIUS,
    C_MARGIN,
    C_PADDING,
    T_TYPO,
    T_MARGIN,
    Q_TYPO,
    Q_MARGIN,
    I_BG,
    I_BORDER,
    I_BRADIUS,
    I_PADDING,
    I_SIZE
} from './constants';

const attributes = {
    items: {
        type: 'array',
        default: []
    },
    titleTag: {
        type: 'string',
        default: 'h3'
    },
    sourceType: {
        type: 'string',
        default: 'library'
    },
    icon: {
        type: 'string',
        default: 'arrow-right'
    },
    customIcon: {
        type: 'string'
    },
    titleColor: {
        type: 'string'
    },
    answerColor: {
        type: 'string'
    },
    iconColor: {
        type: 'string'
    },
    items: {
        type: 'array',
        default: []
    },
    active: {
        type: 'number',
        default: null
    },
    enableAutoNumbering: {
        type: 'boolean',
        default: false
    },
    numberingType: {
        type: 'string',
        default: 'numeric'
    },
    numberingPosition: {
        type: 'string',
        default: 'before'
    },
    showIcon: {
        type: 'boolean',
        default: true
    },
    countColor: {
        type: 'string'
    },
    // color

    // Generator
    ...generateBackgroundAttributes({
        controlName: C_BG
    }),
    ...generateBorderAttributes({
        controlName: C_BORDER
    }),
    ...generateResBoxControlAttributes({
        controlName: C_BRADIUS
    }),
    ...generateResBoxControlAttributes({
        controlName: C_MARGIN
    }),
    ...generateResBoxControlAttributes({
        controlName: C_PADDING
    }),

    // title
    ...generateResBoxControlAttributes({
        controlName: T_MARGIN
    }),
    ...generateTypographyAttributes({
        controlName: T_TYPO
    }),
    // answer
    ...generateResBoxControlAttributes({
        controlName: Q_MARGIN
    }),
    ...generateTypographyAttributes({
        controlName: Q_TYPO
    }),
    // icon
    // icon
    ...generateResRangeAttributes({
        controlName: I_SIZE
    }),
    ...generateBackgroundAttributes({
        controlName: I_BG
    }),
    ...generateBorderAttributes({
        controlName: I_BORDER
    }),
    ...generateResBoxControlAttributes({
        controlName: I_BRADIUS
    }),
    ...generateResBoxControlAttributes({
        controlName: I_PADDING
    }),
    ...generateBackgroundAttributes({
        controlName: I_BG
    })
};

export default attributes;
